import React, { useState, useEffect } from 'react';
import uuid from 'react-uuid';
import _ from 'lodash';
import moment from 'moment';
import { Button, Collapse, Form, Input, Select, Radio, DatePicker, message, InputNumber } from 'antd';
import { RiUserSettingsLine } from 'react-icons/ri';
import { BiSearch } from 'react-icons/bi';
// import {FaFacebookF} from 'react-icons/fa'
import { AiFillInstagram, AiOutlineTwitter, AiOutlineFire, AiFillYoutube } from 'react-icons/ai';
import { GiHumanTarget } from 'react-icons/gi';
import { MdSchedule } from 'react-icons/md';
import './CampStep1Component.styles.scss';
import CampQuickViewComponent from './CampQuickViewComponent';
import { dispatch, useGlobalState } from '../../../../store/state';
import { CampaignDraft } from '../../../../apis/Brand/Campaigns/CampaignDraft';
import { checkObjectKeyValues, dateRangeSeperator } from '../../../../utils';
import { SyncCampiagnData } from '../../../../utils/SyncCampiagnData';
import CampBedCreative from './CampBedCreative';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import PlatformIconRender from '../../../Common/PlatformIconRender';
import { useHistory, useParams } from 'react-router-dom';


const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Item } = Form;
const CampStep1Component = ({ activePanel, className, locations, interests, paymentstatus }) => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [create_camp_general] = useGlobalState('create_camp_general');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [campDefSet] = useGlobalState('campDefSet');
  const [formSet1] = Form.useForm();
  const [formSetBase] = Form.useForm();
  // const [creativeCards,setCreativeCards] =useState([{ uuid:uuid() }]);
  const [creativeFields, setCreativeFields] =useState([]);
  const [panIndiaStatus, setchangePanIndiaStatus] = useState(true);
  const [objSelTree, setObjSelTree] = useState({
    obj: '',
    platform: '',
  });
    // const [createPanelState,setCreatePanelState] =  useState('disabled')
  const changePanIndiaStatus = (e)=>{
    e.target.value === 'All India' ? setchangePanIndiaStatus(true) : setchangePanIndiaStatus(false);
  };
  const disabledDate = (currentDate)=>{
    return currentDate && currentDate < moment().endOf('day').add(3, 'days');
  };
  useEffect(() => {
    console.log('history', params);
    const { influencersettings } = create_camp_draft;
    // set location details[start]
    if (
      influencersettings?.location &&
            influencersettings?.location?.[0] !== 'All India'
    ) {
      setchangePanIndiaStatus(false);
    }
    // set location details[end]
    // object and platform loader[start]
    setObjSelTree({
      ...objSelTree,
      obj: create_camp_draft?.objective || '',
      platform: create_camp_draft?.platform || '',
    });
    // object and platform loader[end]
    const assetModel = { key: null, filename: null, name: null, mime: null, size: null,
      uid: null, url: null };
    if (
      create_camp_draft?.deliverables?.length &&
            create_camp_draft?.deliverables?.[0]?.assets.length &&
            create_camp_draft?.deliverables?.[0]?.assets?.[0]?.hasOwnProperty('url')
    ) {
      const vl = create_camp_draft?.deliverables.map((deliverable) =>{
        const _v = {
          format: deliverable.format,
          creatives: deliverable.creatives,
          assets: deliverable.assets.map((asset) =>{
            asset.name= asset.filename;
            asset.uid = Math.random() * 10000;
            asset.key = Math.random() * 10000;
            return _.pick(asset, _.keys(assetModel));
          }),
        };
        return _v;
      });
      setCreativeFields(vl || []);
    } else {
      setCreativeFields(create_camp_draft?.deliverables || []);
    }
  }, []);
  const saveSetDraft = (btnType)=>{
    console.log('rowDate', formSet1.getFieldValue('campDateTimeRange'));
    // date range spliter
    const _splitDates = dateRangeSeperator(formSet1.getFieldValue('campDateTimeRange') );
    const _formSet1 = formSet1.getFieldsValue();
    // preparing form data to send into draft endpoint
    const _prepData = {
      ...formSetBase.getFieldsValue(),
      ..._formSet1,
      startdate: _splitDates.startdate,
      enddate: _splitDates.enddate,
      // ..._splitDates
    };

    // preparing influencersettings data[start]
    const _infSettings = {
      influencersource: _formSet1.influencersource || [],
      influencerlistid: _formSet1.influencerlistid || null,
      // location:_formSet1.location || [],
      gender: _formSet1.gender || [],
      age: _formSet1.age || [],
      topics: _formSet1.topics || [],
      location: _formSet1.campInfluecnerLocationsRadio === 'other' ? _formSet1.location : ['All India'],
      language: _formSet1.language || [],
    };
    _prepData.influencersettings = checkObjectKeyValues(_infSettings);

    // @note:  converting influencerlistid to string
    // _prepData.influencersettings.influencerlistid =  _formSet1.influencerlistid ? null

    // preparing influencersettings data[end]

    // preparing deliverables data to sent in to _prepData
    const _cretiveData = formSet1.getFieldValue('deliverables') || create_camp_draft?.deliverables;
    // var assetModel = {filename:null,mime:null,size:null,url:null}
    // console.log("_cretiveData", _cretiveData)
    if (_cretiveData) {
      let _f = true;
      const vl = _cretiveData.map((delv) =>{
        if (delv && delv != undefined) {
          // if(delv.format === undefined || delv.creatives === undefined || delv.creatives === '' || delv.assets === undefined || !delv.assets.length){
          if (delv.format === undefined || delv.creatives === undefined || delv.creatives === '') {
            if (_f) {
              message.warning('There is some creatives need to complete!');
            };
            _f = false;
            return false;
          } else {
            const _v = {
              format: delv.format,
              creatives: delv.creatives || 1,
              assets: delv.assets ? delv.assets.map((ic) =>{
                if (ic.response) {
                  const _v_a ={
                    filename: ic.response.response.filename,
                    mime: ic.response.response.mime,
                    size: ic.response.response.size,
                    url: ic.response.response.url,
                  };
                  return _v_a;
                } else {
                  const _v_b = {
                    filename: ic.filename || ic.name,
                    mime: ic.mime,
                    size: ic.size,
                    url: ic.url,
                  };
                  return _v_b;
                }
              }):[],
            };
            return _v;
          }
        }
      });
      // console.log("corrected",vl)
      _prepData.deliverables = vl[0] !== false ? vl : [];
    }

    console.log('finalPrepData to submit ==>', _prepData.deliverables);
    // note: here base data will be saved if campaign not created will create it first
    SyncCampiagnData(
      create_camp_draft, // store sync object
      company.selected.id, // active company id
      campDefSet, // default field set for pre filter
      {
        campaignid: create_camp_draft?.campaignid,
        data: checkObjectKeyValues(_prepData),
      }, // updated set of data to process
    ).then((data)=>{
      CampaignDraft(user.accessToken, checkObjectKeyValues(data, true)).then(({ response, status })=>{
        console.log('response update in ==>', response);
        if (status === 200) {
          SyncCampiagnData(
            create_camp_draft,
            company.selected.id,
            campDefSet,
            {
              campaignid: response.id,
              data: response.object,
            },
          );
          message.success(response.msg); // success msg to show in UI
          // note: if user clicked on save and proceed
          if (btnType === 'proceed') {
            dispatch({
              type: 'SET_CAMP_GENERAL',
              payload: {
                ...create_camp_general,
                currentPanel: 1,
              },
            });
          }
        } else {
          message.error( // erro list print to UI
            <div className="m-0 list-group">
              <h6 className="pt-2">Following issues found</h6>
              {response.errors && response.errors.map((err, index) =>(
                <div className="py-1"
                  key={index}>{err.msg}</div>
              ))}
            </div>,
          );
        }
      });
    });
  };
  const submitBaseData = (submittedData) =>{
    // note: here base data will be saved if campaign not created will create it first
    SyncCampiagnData(
      create_camp_draft, // store sync object
      company.selected.id, // active company id
      campDefSet, // default field set for pre filter
      {
        campaignid: create_camp_draft?.campaignid,
        data: submittedData,
      }, // updated set of data to process
    ).then((data)=>{
      CampaignDraft(user.accessToken, checkObjectKeyValues(data)).then(({ status, response })=>{
        console.log('submit data', response);
        if (status === 200) {
          SyncCampiagnData(
            create_camp_draft,
            company.selected.id,
            campDefSet,
            {
              campaignid: response.id,
              data: response.object,
            },
          );
          message.success('Baisc Details Updated Successfully');
          if (params.companyId !== 'create') {
            history.push(`/brand/${company.selected.id}/campaign/${response.id}`);
          }
        } else {
          message.error(
            <div className="m-0 list-group">
              <h6 className="pt-2">Following issues found</h6>
              <div>There is some issue with Campaign Creation</div>
              {/* {response.errors && response.errors.map((err,index) =>(
                                <div className="py-1" key={index}>{err.msg}</div>
                            ))} */}
            </div>,
          );
        }
      });
    });
  };

  const onObjectiveChange = (value) =>{
    setObjSelTree({
      ...objSelTree,
      obj: value,
    });
    // dispatch({
    //     action:"CREATE_CAMP_DATA",
    //     payload:{
    //         ...create_camp_draft,
    //         platform:undefined
    //     }
    // })
    formSetBase.setFieldsValue({ platform: undefined });
  };
  const onPlatformChange = (value) =>{
    setObjSelTree({
      ...objSelTree,
      platform: value,
    });
  };

  const { defaultSelectBoxData } = create_camp_general;
  return (
  // <div className={`step_data ${current === 0? 'd-block':'d-none'}`}>
    <div className={className}>
      <div className="d-flex py-3">
        <div className="col-md-8 pr-2">
          <Collapse
            className="acc_campaign mb-2 common_collapse"
            showArrow={false}
            defaultActiveKey={['base-1']}
          >
            <Panel showArrow={false}
              key="base-1"
              header={
                <h3><RiUserSettingsLine/> Name and objective</h3>
              }>
              <Form
                form={formSetBase}
                layout={'vertical'}
                requiredMark={false}
                name="campBaseSet"
                onFinish={submitBaseData}
                initialValues={{
                  'creativeRecords': creativeFields,
                }}
              >
                <div className="acc_campaign_set">
                  <div className="row pt-2">
                    <div className="col-md-6 pr-2">
                      <Item
                        initialValue={create_camp_draft?.name || undefined}
                        label="Campaign title"
                        name="name"
                        rules={[{ required: true, message: 'Please enter campaign title' }]}
                      >
                        <Input className="common_input"
                          size="large"
                          placeholder="Enter campaign name" />
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2">
                      <Item
                        initialValue={create_camp_draft?.objective || undefined}
                        label="Campaign objective"
                        name="objective"
                        rules={[{ required: true, message: 'Please select your objective' }]}
                      >
                        <Select
                          className="common_select"
                          onChange={onObjectiveChange}
                          disabled={create_camp_draft?.campaignid ? true : false}
                          size="large"
                          placeholder="Select Objective"
                        >
                          {
                            defaultSelectBoxData.campaignobjective &&
                                                        defaultSelectBoxData.campaignobjective.map((type, index) =>(
                                                          Object.keys(type).map((key, i) => (
                                                            <Option key={`cobj_${i}`}
                                                              value={key}>{key}</Option>
                                                          ))
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pr-2">
                      <Item
                        initialValue={create_camp_draft?.platform || undefined}
                        label="Platform"
                        name="platform"
                        rules={[{ required: true, message: 'Please select your platform' }]}
                      >
                        <Select
                          className="common_select"
                          disabled={create_camp_draft?.campaignid ? true : false}
                          size="large"
                          placeholder="Select Platform"
                          onChange={onPlatformChange}
                        >
                          {
                            defaultSelectBoxData.campaignobjective.length && objSelTree.obj !== '' ?
                              defaultSelectBoxData.campaignobjective[0][objSelTree.obj].map((plat, i) =>(
                                <Option key={`plat_${plat}`}
                                  value={plat}>
                                  <PlatformIconRender platform={plat}/>
                                  <span style={{ textTransform: 'capitalize' }}> {plat}</span>
                                </Option>
                              )):
                              null
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2">
                      <Item
                        initialValue={create_camp_draft?.budget || undefined}
                        label="Budget"
                        name="budget"
                        rules={[{ required: true, message: 'Please add your budget' }]}
                      >
                        <Input
                          disabled={paymentstatus}
                          className="common_input"
                          size="large"
                          type="number"
                          placeholder="Eg:1000"
                          prefix={<CurrencyIcon size={20}/>}
                        />
                      </Item>
                      <Item
                        hidden
                        initialValue={create_camp_draft?.influencerscount || 1}
                        label="No. of influencers"
                        name="influencerscount"
                      >
                        <Input size="large"
                          type="number"
                          placeholder="Eg:1000"/>
                      </Item>
                    </div>
                    {/* <div className="col-md-3 pl-2">
                                        </div> */}
                    <div className="col-md-12 text-right">
                      <Button htmlType="submit"
                        className="common_button outlined">SAVE BASIC DETAILS</Button>
                    </div>
                  </div>
                </div>
              </Form>
            </Panel>
          </Collapse>
          <Form
            form={formSet1}
            layout={'vertical'}
            requiredMark={false}
            name="campSet1Form"
          >
            <Collapse
              collapsible={create_camp_draft?.campaignid? true : 'disabled'}
              className="acc_campaign common_collapse"
              showArrow={false}
              defaultActiveKey={[]}
            >
              <Panel showArrow={false}
                key="panel-2"
                header={<h3><GiHumanTarget /> Target Influencers</h3>}>
                <div className="acc_campaign_set">
                  <div className="row pt-2">
                    <div className="col-md-6 pr-2">
                      <Item
                        label="Influencer Type"
                        name="influencersource"
                        initialValue={create_camp_draft?.influencersettings?.influencersource || undefined}
                      >
                        <Select
                          className="common_select"
                          size="large"
                          showArrow={true}
                          mode="multiple"
                          placeholder="Select"
                          maxTagCount="responsive"
                        >
                          {
                            defaultSelectBoxData.influencertype &&
                                                        defaultSelectBoxData.influencertype.map((type, index) =>(
                                                          <Option key={`type_${index}`}
                                                            value={type}>{type}</Option>
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-3 px-2">
                      <Item
                        label="Gender"
                        required
                        name="gender"
                        initialValue={create_camp_draft?.influencersettings?.gender || undefined}
                      >
                        <Select className="common_select"
                          size="large"
                          showArrow={true}
                          mode="multiple"
                          placeholder="Select"
                          maxTagCount="responsive">
                          {defaultSelectBoxData.gender &&
                                                        defaultSelectBoxData.gender.map((gen, i) =>(
                                                          <Option key={`gender_${i}`}
                                                            value={gen}>{gen}</Option>
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-3 pl-2">
                      <Item
                        label="Age Group"
                        name="age"
                        initialValue={create_camp_draft?.influencersettings?.age || undefined}
                      >
                        <Select className="common_select"
                          size="large"
                          showArrow={true}
                          mode="multiple"
                          maxTagCount="responsive"
                          placeholder="Select">
                          {defaultSelectBoxData.age &&
                                                        defaultSelectBoxData.age.map((ag, i) =>(
                                                          <Option key={`age_${i}`}
                                                            value={ag}>{ag}</Option>
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pr-2">
                      <Item
                        label="Languages"
                        name="language"
                        initialValue={create_camp_draft?.influencersettings?.language || undefined}
                      >
                        <Select className="common_select"
                          size="large"
                          mode="tags"
                          maxTagCount="responsive"
                          placeholder={<><BiSearch size={18}/> Search</>}
                          allowClear>
                          {defaultSelectBoxData.language &&
                                                        defaultSelectBoxData.language.map((lang, i) =>(
                                                          <Option key={`lang_${i}`}
                                                            value={lang}>{lang}</Option>
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2">
                      <Item
                        label="Interests"
                        name="topics"
                        initialValue={create_camp_draft?.influencersettings?.topics || undefined}
                      >
                        <Select className="common_select"
                          size="large"
                          mode="tags"
                          maxTagCount="responsive"
                          placeholder={<><BiSearch size={18}/> Search</>}>
                          {/* {interests && interests.map((int)=>(
                                                        <Option key={int} value={int}>{int}</Option>
                                                    ))} */}
                          {defaultSelectBoxData.topics &&
                                                        defaultSelectBoxData.topics.map((topic, i) =>(
                                                          <Option key={`topic_${i}`}
                                                            value={topic}>{topic}</Option>
                                                        ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pr-2">
                      <Item
                        className="mb-3"
                        label="Locations"
                        initialValue={panIndiaStatus? 'All India':'other'}
                        onChange={changePanIndiaStatus}
                        name="campInfluecnerLocationsRadio">
                        <Radio.Group
                        >
                          <Radio.Button value="All India">All India</Radio.Button>
                          <Radio.Button value="other">Other Locations</Radio.Button>
                        </Radio.Group>
                      </Item>
                      <Item
                        required
                        name="location"
                        initialValue={!panIndiaStatus ? create_camp_draft?.influencersettings?.location: undefined}
                      >
                        <Select
                          disabled={panIndiaStatus}
                          className="common_select"
                          size="large"
                          mode="multiple"
                          maxTagCount="responsive"
                          placeholder={<><BiSearch size={18}/> Search Locations</>}
                          allowClear>
                          {/* {locations && locations.map((loc) =>(
                                                            loc !== 'All India'?
                                                            <Option key={loc} value={loc}>{loc}</Option>
                                                            :null
                                                        ))} */}

                          {defaultSelectBoxData.locations &&
                                                            defaultSelectBoxData.locations.map((loc, i) =>(
                                                              loc !== 'All India' ?
                                                                <Option key={`loc_${i}`}
                                                                  value={loc}>{loc}</Option>:
                                                                null
                                                            ))
                          }
                        </Select>
                      </Item>
                    </div>
                    <div className="col-md-6 pl-2 align-self-end">
                      <Item
                        label="Influencers List"
                        name="influencerlistid"
                        initialValue={create_camp_draft?.influencersettings?.influencerlistid || undefined}
                      >
                        <Select className="common_select"
                          size="large"
                          placeholder={<><BiSearch size={18}/> Search</>}
                          allowClear>
                          {
                            defaultSelectBoxData.influencerListSet &&
                                                        defaultSelectBoxData.influencerListSet.map(({ listname, _id, platform }) =>{
                                                          if (create_camp_draft?.platform === platform) {
                                                            return <Option key={_id}
                                                              value={_id}>{listname}</Option>;
                                                          } else {
                                                            return null;
                                                          }
                                                        })
                          }
                          {/* <Option value="Tech">Technology</Option> */}
                        </Select>
                      </Item>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel showArrow={false}
                key="panel-3"
                header={<h3><MdSchedule/> Schedule</h3>} >
                <div className="acc_campaign_set">
                  <div className="row pt-2">
                    <div className="col-md-12">
                      <Item
                        initialValue={[(create_camp_draft?.startdate ? moment(create_camp_draft?.startdate) : undefined), (create_camp_draft?.enddate ? moment(create_camp_draft?.enddate) : undefined)]}
                        label="Select start & end Date with time (required)"
                        name="campDateTimeRange"
                      >
                        <RangePicker
                          className="common_input"
                          style={{ width: '100%' }}
                          disabledDate={disabledDate}
                          size="large"
                          format="Do MMM yyyy HH:mm a"
                          showTime={{ defaultValue: [moment('00:00', 'HH:mm'), moment('11:59', 'HH:mm')] }}
                          rules={ [{ type: 'object', required: true, message: 'Please select start & end date with time' }] }
                        />
                      </Item>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel showArrow={false}
                key="panel-4"
                header={
                  <h3 className="d-flex align-items-center justify-content-between">
                    <div>
                      <AiOutlineFire/> Creatives
                    </div>
                    <div className="extras">
                      <span style={{ fontSize: '0.8rem', marginRight: 10 }}>Total Creatives: {creativeFields ? creativeFields.length : 0}</span>
                      {/* <Button
                                                disabled={create_camp_draft.campaignid? false : true}
                                                className="common_button"
                                                onClick={addNewCreativeCard}
                                            >
                                                ADD CREATIVE
                                            </Button> */}
                    </div>
                  </h3>
                }
              >
                <div className="creative_cards">
                  <Form.List name="deliverables"
                    initialValue={creativeFields}>
                    {(fields, { add, remove }, { errors }) => {
                      // console.log("parent",fields)
                      return (
                        <React.Fragment key={`parent_${uuid()}`}>
                          {fields.map((field, index) => {
                            // console.log("flnest",field)
                            return (
                              <CampBedCreative
                                key={`child_${uuid()}`}
                                childKey={`child_${uuid()}`}
                                indx={index}
                                cardName={field.name}
                                pRemove={remove}
                                taskTypes={defaultSelectBoxData[objSelTree.platform] || []}
                              />
                            );
                          })}
                          <Form.Item>
                            <Button
                              size="large"
                              type="dashed"
                              onClick={() => add()}
                              style={{ width: '100%' }}
                            >
                                                     Add new Creative
                            </Button>
                          </Form.Item>
                        </React.Fragment>
                      );
                    }}
                  </Form.List>
                  {/* {creativeCards.map(({uuid},index) => (
                                        <CreativeCardComponent
                                            key={index}
                                            cardIndex={index}
                                            deleteCard={deleteCard}
                                            saveCard={saveCreativeCard}
                                            uuid={uuid}
                                        />
                                    ))} */}

                </div>
              </Panel>
            </Collapse>
          </Form>

          {/* proceed button [start]*/}
          <Button className="mt-2 common_button w-100"
            onClick={() => saveSetDraft('proceed')}>Save &amp; proceed</Button>
          {/* proceed button [end]*/}
        </div>
        <div className="col-md-4 pl-2">
          {create_camp_draft?.campaignid?
            <CampQuickViewComponent
              onSaveDraft={saveSetDraft}
            />:
            null
          }
        </div>
      </div>
    </div>
  );
};

export default CampStep1Component;
